import { Nullable } from '@cast/leadcast-types';
import { Geometry } from 'types/models/Geometry';
import { ServiceLineSide } from 'types/models/ServiceLine';
import { ServiceLineType } from './ServiceLineType';

type ServiceLine = {
  id: string;
  externalId: string;
  length: number;
  contract: string;
  diameter: number;
  previouslyLead: boolean;
  connectorStatus: string;
  installationDate: string;
  connectorMaterial: string;
  serviceLineType: ServiceLineType;
  comments: Nullable<string>;
  tapSize: Nullable<string>;
  startDate: Nullable<string>;
  endDate: Nullable<string>;
  waterMainDiameter: Nullable<number>;
  containsLeadSolder: Nullable<boolean>;
  previousLeadSource: Nullable<string>;
  previousLeadConnector: Nullable<string>;
  otherFittingsContainingLead: string;
  createdOnDate: Nullable<Date>;
  lastModifiedDate: Nullable<Date>;
  properties: Nullable<Record<string, string | number>>;
};

export type Material = {
  id: string;
  method:
    | 'Electrical Resistance Test'
    | 'Lead Swab Test'
    | 'Magnet Test'
    | 'Visual Inspection'
    | 'XRF Analysis';
  source: string;
  status: string;
  material: string;
  installDate: string;
  serviceLineId: string;
  isInspectionRequired: Nullable<boolean>;
};

enum LeadLikelihood {
  Low = 'Low',
  Med = 'Medium',
  High = 'High',
}

export default interface DataTableRecord {
  id: string;
  externalId: string;
  accountId: string;
  address: string;
  unit: string;
  city: string;
  state: string;
  zipcode: string;
  yearBuilt: number;
  zoneName: string;
  pwsId: string;
  parcelId: string;
  buildingType: string;
  buildingTypeDescription: string;
  geometry: Geometry;
  replacementPoolId: string;
  leadScore: number;
  leadLikelihood: LeadLikelihood;
  privateServiceLines: ServiceLine[] | null;
  utilityServiceLines: ServiceLine[] | null;
  leadStatus: string;
  privateMaterials: Material[] | null;
  privateLeadStatus: string;
  utilityMaterials: Material[] | null;
  utilityLeadStatus: string;
  serviceLineSidesInReplacementPool: Nullable<ServiceLineSide | 'Both'>;
}
